module.exports = __webpack_public_path__ + "static/media/img_14.9313a3fd.png";